import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";
import { IconButton, Paper, Stack, Tooltip, Typography } from "@mui/material";
import type { ReactNode } from "react";

const PANEL_WIDTH = 280;

interface Props {
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
}

export const FiltersPanel = ({ open, onToggle, children }: Props) => {
  if (!open) {
    return (
      <Paper
        elevation={1}
        sx={{ p: 0.5, flexShrink: 0, alignSelf: "flex-start" }}
      >
        <Tooltip title="Show filters" placement="right">
          <IconButton
            size="small"
            onClick={onToggle}
            aria-label="Show filters"
            data-testid="show-filters-panel"
          >
            <ChevronRightIcon />
          </IconButton>
        </Tooltip>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={1}
      sx={{
        p: 1.5,
        width: PANEL_WIDTH,
        flexShrink: 0,
        alignSelf: "flex-start",
      }}
      data-testid="filters-panel"
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 1.5 }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Filters
        </Typography>
        <Tooltip title="Hide filters">
          <IconButton
            size="small"
            onClick={onToggle}
            aria-label="Hide filters"
            data-testid="hide-filters-panel"
          >
            <ChevronLeftIcon />
          </IconButton>
        </Tooltip>
      </Stack>
      {children}
    </Paper>
  );
};
